import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function ListCard({ label, items }: { label: string; items?: string[] | null }) {
  if (!items || items.length === 0) return null;
  return (
    <Card>
      <CardHeader>
        <CardTitle>{label}</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="flex flex-wrap gap-1.5">
          {items.map((it, i) => (
            <li
              key={i}
              className="rounded-md border border-border bg-muted/40 px-2 py-1 text-xs text-foreground/90"
            >
              {it}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
